import { render, staticRenderFns } from "./OrderDiscountModal.vue?vue&type=template&id=004b417e"
import script from "./OrderDiscountModal.vue?vue&type=script&lang=js"
export * from "./OrderDiscountModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports